import {AuthenticationProvider} from '../providers/authentication/authentication';
import {BrowserModule} from '@angular/platform-browser';
import {ComponentsModule} from '../components/components.module';
import {ConfigurationProvider} from '../providers/configuration/configuration';
import {CookandeatApiProvider} from '../providers/cookandeat-api/cookandeat-api';
import {ErrorHandler, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Http, HttpModule, RequestOptions, XHRBackend} from '@angular/http';
import {HttpServiceProvider} from '../providers/http-service/http-service';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {MyApp} from './app.component';
import {TranslateHttpLoader} from '../utils/translate-http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NfcServiceProvider} from '../providers/nfc-service/nfc-service';
import {AudioServiceProvider} from '../providers/audio-service/audio-service';
import {UiServiceProvider} from "../providers/ui-service/ui-service";
import {ServiceService} from "../providers/gastroflow-services/service-service/service-service";
import {OrderService} from "../providers/gastroflow-services/order-service/order-service";
import {BusinessService} from "../providers/gastroflow-services/business-service/business-service";
import {UserService} from "../providers/gastroflow-services/user-service/user-service";

export class MyErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    console.log(err);
  }
}

export function TranslateFactory(http: Http) {
  return new TranslateHttpLoader(http);
}

export function HttpServiceFactory(backend: XHRBackend, options: RequestOptions) {
  return new HttpServiceProvider(backend, options);
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      backButtonText: "",
      statusbarPadding: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateFactory,
        deps: [Http]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    },
    {
      provide: HttpServiceProvider,
      useFactory: HttpServiceFactory,
      deps: [XHRBackend, RequestOptions]
    },
    [{
      provide: ErrorHandler,
      useClass: MyErrorHandler
    }],
    {provide: 'Window', useValue: window},
    ConfigurationProvider,
    AuthenticationProvider,
    CookandeatApiProvider,
    NfcServiceProvider,
    AudioServiceProvider,
    UiServiceProvider,
    OrderService,
    ServiceService,
    BusinessService,
    UserService
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts